import { Modal } from '@marriott/mi-ui-library';
import { useModalPageContent } from '../../hooks/useTermPageContent';
import { TermModalBody } from './TermModalBody';

export function ConsentTermModal({ href, onModalClose }: { href: string; onModalClose: () => void }) {
  const state = useModalPageContent(href);
  const { isLoading, isError, data: termPage } = state;

  return (
    <Modal
      role="dialog"
      labelledBy="termsModalLabel"
      show={true}
      popupOpenState={true}
      handleBlur={true}
      disableScrollOnBody={true}
      setPopupOpenState={onModalClose}
      onClose={onModalClose}
    >
      {isLoading ? (
        <div data-testid="skeleton-loader" className="skeleton-loader" />
      ) : (
        <Modal.Header
          labelText={isError ? 'Error' : termPage.heading}
          customHeadingClass="t-subtitle-xl"
          closeBtnAriaLabel="close-button"
          popupHeaderOnCLoseFunc={onModalClose}
        />
      )}
      <Modal.Body className="p-0">
        <TermModalBody {...state} />
      </Modal.Body>
    </Modal>
  );
}
